import { render, staticRenderFns } from "./CustomUserDetail.vue?vue&type=template&id=1f2ef819&scoped=true&"
import script from "./CustomUserDetail.vue?vue&type=script&lang=js&"
export * from "./CustomUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomUserDetail.vue?vue&type=style&index=0&id=1f2ef819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ef819",
  null
  
)

export default component.exports